import { LiveConst } from "../../../constants/live";
import * as LiveActions from '../../../redux/live/actions';
import { confirmAlert } from 'react-confirm-alert';
import { CiMenuBurger } from "react-icons/ci";
import Dropdown from 'react-bootstrap/Dropdown';


const CellaEventoTennis = (props) => {
    let heightEvento = props.style.height - 1;
    return(
        <>
        <style>
        {`
    .dropstart .dropdown-toggle::before {
      display: none;
    }
    `}
        </style>
        {props && props.evento &&
            <div className="col overflow-hidden cellaevento">
                <div className="row">
                    <div className="col-1 p-1 pt-3" style={{backgroundColor: '#999', borderRight: '1px solid gray'}}>
                        <Dropdown drop="start" style={{display: 'flex', justifyContent: 'center', position: 'absolute'}}>
                            <Dropdown.Toggle split style={{padding: "0px", margin: "0px", border: "0px", background: "transparent" }} >
                                <CiMenuBurger size={12} color="black" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu style={{fontSize: '14px'}}>
                                <Dropdown.Item onClick={()=>{props.removeEvento(props.evento.pevento_id)}}>Rimuovi Evento</Dropdown.Item>
                                <Dropdown.Item onClick={()=>{props.removeCampionato(props.evento.pcampionato_id, props.evento.descrizione)}}>Ignora Campionato</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>                    
                    </div>
                    <div style={{backgroundColor: 'lightgray', color: 'black'}} className="col text-nowrap overflow-hidden p-0">
                        <div className="col-12 p-1" style={{height:LiveConst.ALTEZZA_RIGA_CONCESSIONARIO}}>
                            <div className="row">
                                <div className="col-10" style={{overflow: "hidden"}}>
                                    {props.evento.home}
                                </div>
                                <div className="col-2" style={{paddingTop:"6px", paddingLeft: "6px"}}>
                                        {props.evento.info_live && props.evento.info_live.serviceGame && props.evento.info_live.serviceGame.home == true && (
                                            <div className="cellaevento-statoServizio"></div>
                                        )}
                                </div>
                            </div>
                        </div>
                        <div className="col-12 p-1" style={{height:LiveConst.ALTEZZA_RIGA_CONCESSIONARIO}}>
                            <div className="row">
                                <div className="col-10" style={{overflow: "hidden"}}>
                                    {props.evento.away}
                                </div>
                                <div className="col-2" style={{paddingTop:"6px", paddingLeft: "6px"}}>
                                        {props.evento.info_live && props.evento.info_live.serviceGame && props.evento.info_live.serviceGame.away == true && (
                                            <div className="cellaevento-statoServizio"></div>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-auto">
                        <div className="row p-0 text-center">
                            {props.evento.info_live && props.evento.info_live.totalSets &&
                                props.evento.info_live.totalSets.map((set, index) =>
                                    <div style={{backgroundColor: 'black', minWidth: '24px'}} className="col-auto p-0 text-center" key={index}>
                                        <div className="col-12 p-1" style={{height:LiveConst.ALTEZZA_RIGA_CONCESSIONARIO}}>{set && set.home}</div>
                                        <div className="col-12 p-1" style={{height:LiveConst.ALTEZZA_RIGA_CONCESSIONARIO}}>{set && set.away}</div>    
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <div style={{backgroundColor: 'green', 'width': '25px'}} className="col-2 p-0 text-center">
                            <div className="col-12 p-1" style={{height:LiveConst.ALTEZZA_RIGA_CONCESSIONARIO}}>{props.evento.info_live && props.evento.info_live.currentGame.home}</div>
                            <div className="col-12 p-1" style={{height:LiveConst.ALTEZZA_RIGA_CONCESSIONARIO}}>{props.evento.info_live && props.evento.info_live.currentGame.away}</div>
                    </div>
                </div>
                <div className="row">
                    <div style={{color: 'darkgray'}}  className="col-12 p-1 text-center">
                        {props.evento.descrizione}
                    </div>
                    {/* {props.evento.data_attivazione_alert &&                     
                        <div style={{color: 'darkgray'}}  className="col-12 p-1 text-center">
                            Alert Attivato alle: {props.evento.data_attivazione_alert.toLocaleTimeString('it-IT', {hour: '2-digit', minute:'2-digit', second: '2-digit'})}    
                        </div>

                    } */}

                </div>
            </div>
            
        }
        
        </>
    );
}
export default CellaEventoTennis;